import { useMemo } from 'react';
import {
  DemandProductOption,
  toDemandProductOption,
} from '../components/demand/WarehouseDemandRequestForm.schema';
import { useProductPickerPage } from './useProductPickerPage';
import { DEMAND_PICKER_KEY_PART } from './warehouseDemandQueryKeys';

const NO_OPTIONS: DemandProductOption[] = [];

export interface DemandProductOptionsResult {
  options: DemandProductOption[];
  isLoading: boolean;
}

/**
 * The demand form's Product search: a first page of active Products. Key
 * `demandProductPickerKey(organizationId, search)`; no previous data is kept,
 * so a clinic switch never offers the previous clinic's Products (S3).
 */
export function useDemandProductOptions(
  search: string,
  enabled: boolean,
): DemandProductOptionsResult {
  const { products, isLoading } = useProductPickerPage(
    DEMAND_PICKER_KEY_PART,
    search,
    enabled,
  );
  const options = useMemo(
    () => (products ? products.map(toDemandProductOption) : NO_OPTIONS),
    [products],
  );
  return { options, isLoading };
}
